import { TextField } from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';

const VrmComponent: React.FC<{
  vrm: string;
  disabled: boolean;
  setVrm: (vrm: string) => void;
  error?: boolean;
  helperText?: string;
  suffix?: string;
}> = ({ vrm, disabled, setVrm, error, helperText, suffix }) => (
  <TextField
    id={'vrm-input'}
    label={`${t('vehicleRegistration')}${suffix || ''}`}
    disabled={disabled}
    value={vrm}
    fullWidth
    error={error}
    helperText={helperText}
    onChange={(e) => setVrm(e.target.value)}
  />
);

export const useVrm = (initialVrm: string = '') => {
  const [vrm, setVrm] = useState<string>(initialVrm);

  return { vrm, VrmComponent, setVrm };
};
